var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackoorangLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2239 14.3117C31.305 13.7374 27.9103 15.5751 27.4636 15.7666C26.2513 14.4648 24.9623 13.1759 24.2093 13.5204C23.2649 13.9544 25.6514 18.9443 26.8128 19.0592C27.8976 19.174 33.2576 14.9498 32.2239 14.3117Z",
    fill: "#22D081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0513 9.01566C24.0942 9.62824 27.5144 12.3976 28.3439 12.2827C29.5308 12.1296 31.1005 8.14784 30.1816 8.02022C29.2628 7.8926 28.1014 9.99834 28.1014 9.99834C28.1014 9.99834 25.766 8.55623 25.0513 9.01566Z",
    fill: "#22D081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3918 6.99916C27.1193 6.3483 26.4173 2.67283 25.5623 2.96636C25.0901 3.13227 25.1029 4.89343 25.1411 5.45496C24.5286 5.35286 22.2569 5.238 22.308 5.91439C22.3463 6.64182 25.6644 7.63726 26.3918 6.99916Z",
    fill: "#22D081"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8848 3.63006C13.7827 5.25084 13.502 8.37754 14.893 8.17334C16.2841 7.68839 16.718 2.71119 16.0544 2.1369C15.1355 1.34566 9.27773 0.350219 9.0863 1.46052C8.89487 2.57081 12.1109 3.42587 13.8848 3.63006Z",
    fill: "#22D081"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9741 13.0868C16.1437 12.9847 10.9495 5.86352 8.80551 5.68485C6.01063 5.45513 -2.74412 12.972 0.854769 12.8699C2.24583 12.8316 4.13461 11.9638 8.38437 9.3986C8.55027 9.52622 12.8 13.1506 13.9741 13.0868Z",
    fill: "#22D081"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9761 22.1607H21.9633C22.1165 20.4506 23.265 15.9966 21.8357 15.8945C19.3599 16.1498 17.5732 23.2582 18.3644 24.3685C19.781 26.3466 28.5996 27.0485 29.6461 25.3895C30.3224 24.2919 27.5531 23.1817 21.9761 22.1607Z",
    fill: "#22D081"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31699 16.0219C3.77734 18.6382 6.9168 26.8569 9.18844 30.0602C10.018 31.2215 11.5367 32.9572 12.5193 31.3491C13.7317 29.1924 11.6005 22.8241 10.6561 19.2507C13.1319 18.7275 17.6241 18.0766 18.007 16.6728C18.4537 15.0648 7.96329 14.3246 6.31699 16.0219Z",
    fill: "#22D081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackoorangLogo);
export default __webpack_public_path__ + "static/media/packoorangLogo.21d9646de8349679a1808a9ccc0182ff.svg";
export { ForwardRef as ReactComponent };